import { useQuery } from "@tanstack/react-query";
import { loadStripe } from "@stripe/stripe-js";

/**
 * Loads a Stripe.js instance scoped to the given publishable key/Connect account, cached by that
 * pair so switching between orgs (or an unset key while checkout data resolves) doesn't re-trigger
 * a load until the key/account combination actually changes. Shared query key so this action has
 * one consistent cache identity anywhere in the shop it's needed from.
 */
export const useLoadStripeInstance = (publishableKey: string | undefined, stripeAccount: string | undefined) =>
  useQuery({
    queryKey: ["shop", "loadStripe", { publishableKey, stripeAccount }],
    queryFn: () => loadStripe(publishableKey ?? "", { stripeAccount }),
    enabled: !!publishableKey,
  });
